import { render } from "./HomeBody.vue?vue&type=template&id=d1517526&scoped=true"
import script from "./HomeBody.vue?vue&type=script&lang=js"
export * from "./HomeBody.vue?vue&type=script&lang=js"

import "./HomeBody.vue?vue&type=style&index=0&id=d1517526&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1517526"]])

export default __exports__